import { render, staticRenderFns } from "./createModuleFormTemplate.vue?vue&type=template&id=544978f0&"
import script from "./createModuleFormTemplate.vue?vue&type=script&lang=ts&"
export * from "./createModuleFormTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports